import { TermsAndConditionsInterface } from "../domain/TermsAndConditions.interface";
import { DirectusEntityPayload } from "../types/termsAndConditions.types";
import { DirectusAvailableLanguages } from "../../types/directus.types";
import { DirectusService } from "../../directus.service";
import { ApiUtils } from "@/modules/api/Api.utils";
import { fetchWrapper } from "@chatsystem/common/utils";

export class TermsAndConditionsRepository
  implements TermsAndConditionsInterface
{
  async get(lang: DirectusAvailableLanguages): Promise<DirectusEntityPayload> {
    "use server";
    const query = DirectusService.buildEntityQuery(
      "TermsAndConditions_translations"
    );
    const urlComplete = DirectusService.addLanguageToQuery(query, lang);

    const fetchConfig = ApiUtils.getFetchConfig({});

    const resp = await fetchWrapper(urlComplete, fetchConfig);

    const termsAndConditions = await (resp as Response).json();

    return termsAndConditions as DirectusEntityPayload;
  }
}
